<!-- RIEPILOGO ORDINE -->
<div class="b2">
    <div *ngIf="order && !interfaceChangesForDubai()" id="fixedresume" class="com-cont" [ngClass]="{
        'openBox': orderSummaryBoxStatus,
        'closeBox': !orderSummaryBoxStatus,
        'limitWidth': !showFieldsNotYetImplemented
    }" cdkDrag [cdkDragFreeDragPosition]="dragPosition">

        <mat-toolbar color="primary" class="moveCursor" cdkDragHandle>
            <button (click)="toggleOrderSummaryBox($event)" mat-icon-button>
                <mat-icon>{{orderSummaryBoxIcon}}</mat-icon>
            </button>
            <span (click)="toggleOrderSummaryBox($event)" class="title">{{'LABEL.RiepilogoOrdine' | translate }}</span>
        </mat-toolbar>

        <div class="box" *ngIf="orderSummaryBoxStatus">

            <div class="card-title">
                <span class="material-icons-outlined">vpn_key</span>
                <div class="c1">&nbsp;{{'LABEL.Codice' | translate }}</div>
                <div class="c2_1"><b>{{order.code}}</b></div>
                <div class="c3_1">&nbsp; </div>
                <div class="c4_1">

                </div>
            </div>
            <div class="card-title">
                <span class="material-icons-outlined">person</span>
                <div class="c1">&nbsp;{{'LABEL.UltimaModifica' | translate }}</div>
                <div class="c2"><b>{{order.who}}</b></div>
            </div>
            <div class="card-title">
                <div class="c1"><span class="material-icons-outlined">attach_money</span>&nbsp;{{'LABEL.RicavoStandard'
                    |
                    translate }}</div>
                <div class="c1"><b>{{getRicavoTotale() | number: '1.2-2'}}</b></div>
                <div class="c1 flexColumn">
                    <div class="full"><span class="material-icons-outlined">payments</span>&nbsp;{{'LABEL.CostoStandard'
                        |
                        translate }}</div>
                    <div class="full" *ngIf="itIsAConventionPractice()"><span
                            class="material-icons-outlined">payments</span>&nbsp;{{'LABEL.CostoConvenzione' |
                        translate }}</div>
                </div>
                <div class="c1 flexColumn">
                    <div class="full"><b>{{getCostoTotale() | number: '1.2-2'}}</b></div>
                    <div class="full" *ngIf="itIsAConventionPractice()"><b>{{getConventionCost() | number: '1.2-2'}}</b>
                    </div>
                </div>

                <div *ngIf="showFieldsNotYetImplemented" class="c1"><span
                        class="material-icons-outlined">attach_money</span>&nbsp;{{'LABEL.MaterialePreventivato' |
                    translate }}</div>
                <div *ngIf="showFieldsNotYetImplemented" class="c1"><b>{{getMaterialePreventivato()}}</b></div>

                <div class="c1"><span class="material-icons-outlined">savings</span>&nbsp;{{'LABEL.MargineStandard' |
                    translate }}</div>
                <div class="c1"><b>{{getMargineTotale() | number: '1.2-2'}}%</b></div>
            </div>
            <div class="card-title">
                <div class="c1"><span class="material-icons-outlined">attach_money</span>&nbsp;{{'LABEL.RicavoReale' |
                    translate }}</div>
                <div class="c1">
                    <b>{{getRicavoReale() | number: '1.2-2'}}</b>
                </div>
                <div class="c1">
                    <div>
                        <span class="material-icons-outlined">attach_money</span>&nbsp;{{'LABEL.CostoOneriSicurezza'
                        |
                        translate }}
                    </div>
                </div>
                <div class="c1">

                    <b>{{getOneriReale() | number: '1.2-2'}}</b>
                </div>

                <div class="c1"><span
                        class="material-icons-outlined">account_balance</span>&nbsp;{{'LABEL.CostoOneriFinanziamento'
                    |
                    translate }}
                </div>
                <div class="c1">

                    <b>{{getOneriFinanziamento() | number: '1.2-2'}}</b>
                </div>

                <div class="c1" [ngStyle]="{color:getColorMargin()}"><span
                        class="material-icons-outlined">savings</span>&nbsp;{{'LABEL.MargineReale' | translate
                    }}</div>
                <div class="c1" [ngStyle]="{color:getColorMargin()}"><b>{{getMargineReale() | number: '1.2-2'}}%</b>
                </div>
            </div>
            <div class="card-title">
                <div class="c1"><span class="material-icons-outlined">attach_money</span>&nbsp;{{'LABEL.DeliberatoReale'
                    |
                    translate }}</div>
                <div class="c1">
                    <b>{{getValueDeliber() | number: '1.2-2'}}</b>
                </div>
                <div class="c1"><span class="material-icons-outlined">attach_money</span>&nbsp;{{'LABEL.CostoCessione' |
                    translate }}
                </div>
                <div class="c1">
                    <b>{{getCostoCessione() | number: '1.2-2'}}</b>
                </div>

                <div class="c1"><span
                        class="material-icons-outlined">account_balance</span>&nbsp;{{'LABEL.MaggFinanziamento' |
                    translate }}
                </div>
                <div class="c1">
                    <b>{{getMaggiorazioneFinanziamento() | number: '1.2-2'}}</b>
                </div>

                <div class="c1"><span class="material-icons-outlined">attach_money</span>&nbsp;{{'LABEL.Venduto' |
                    translate }}</div>
                <div class="c1"><b>{{getCostoVenduto() | number: '1.2-2'}}</b></div>
            </div>

            <div *ngIf="showFieldsNotYetImplemented" class="card-title">
                <div class="c1"></div>
            </div>

            <div *ngIf="showFieldsNotYetImplemented" class="card-title">

                <div class="c1"><span
                        class="material-icons-outlined">hourglass_empty</span>&nbsp;{{'LABEL.OreDeliberate'
                    |
                    translate }}</div>
                <div class="c1">
                    <b>{{getOreDeliberate()}}</b>
                </div>

                <div class="c1"><span class="material-icons-outlined">attach_money</span>&nbsp;{{'LABEL.ValoreProdotto'
                    |
                    translate }}
                </div>
                <div class="c1">
                    <b>{{getValoreProdotto()}}</b>
                </div>

                <div class="c1"><span
                        class="material-icons-outlined">attach_money</span>&nbsp;{{'LABEL.MaggiorazioneSegnalatori' |
                    translate }}</div>
                <div class="c1"><b>{{getSignallersSurcharge() | number: '1.2-2'}}</b></div>

                <div class="c1"><span class="material-icons-outlined">attach_money</span>&nbsp;{{'LABEL.Certificato' |
                    translate }}</div>
                <div class="c1"><b>{{getCertificato()}}</b></div>
            </div>

            <div *ngIf="showFieldsNotYetImplemented" class="card-title">

                <div class="c1"><span
                        class="material-icons-outlined">hourglass_empty</span>&nbsp;{{'LABEL.OrePianificate'
                    |
                    translate }}</div>
                <div class="c1">
                    <b>{{getOrePianificate()}}</b>
                </div>

                <div class="c1"><span
                        class="material-icons-outlined">percent</span>&nbsp;{{'LABEL.PercentualeAvanzamentoSAL' |
                    translate }}
                </div>
                <div class="c1">
                    <b>{{getPercentualeAvanzamentoSAL()}}</b>
                </div>

                <div class="c1"><span
                        class="material-icons-outlined">attach_money</span>&nbsp;{{'LABEL.MaterialeConsuntivato' |
                    translate }}</div>
                <div class="c1"><b>{{getMaterialeConsuntivato()}}</b></div>

                <div class="c1"><span class="material-icons-outlined">attach_money</span>&nbsp;{{'LABEL.Fatturato' |
                    translate }}</div>
                <div class="c1"><b>{{getFatturato()}}</b></div>
            </div>

            <div *ngIf="showFieldsNotYetImplemented" class="card-title">

                <div class="c1"><span
                        class="material-icons-outlined">hourglass_empty</span>&nbsp;{{'LABEL.OreConsuntivate' |
                    translate }}</div>
                <div class="c1">
                    <b>{{getOreConsuntivate()}}</b>
                </div>

                <div class="c1">
                    <span class="material-icons-outlined">attach_money</span>&nbsp;<span>{{'LABEL.ValoreTragitto' |
                        translate }}
                    </span>
                </div>
                <div class="c1">
                    <b>{{preventivoTragitti() | number: '1.2-2'}}</b>
                </div>

                <div class="c1"><span
                        class="material-icons-outlined">percent</span>&nbsp;{{'LABEL.PercentualeIncidenzaMateriali'
                    |
                    translate }}</div>
                <div class="c1"><b>{{getPercentualeIncidenzaMateriali()}}</b></div>

                <div class="c1"><span class="material-icons-outlined">attach_money</span>&nbsp;{{'LABEL.Incassato' |
                    translate }}</div>
                <div class="c1"><b>{{getIncassato()}}</b></div>
            </div>

        </div>
    </div>


</div>

<!-- PRATICA -->
<div class="container-fluid my-container">

    <div class="b2">

        <div class="com-cont" style="width:100%">
            <div class="card-title">
                <div class="cb">
                    <span>{{ getStatusLabel(practice?.StateId) | translate}}</span>
                </div>
            </div>

            <div class="card-title" *ngIf="itIsAConventionPractice()" style="color:#55ca12;">
                <b>{{getConventionLabel() | translate }}</b>
            </div>

            <div class="card-title" *ngIf="itIsASignalerPractice()" style="color:#55ca12;">
                <div class="signalerInfoBox" [innerHTML]="getSignalerLabel() | safeHtml"></div>
            </div>

            <div class="card-title" *ngIf="isWarningApprove() == true" style="color:#833d29;"> <mat-icon
                    class="material-icons">warning</mat-icon>{{'LABEL.WARNING_APPROVAL' | translate}}</div>
            <div class="card-title" *ngIf="isWarningApproveOver() == true" style="color:#833d29;"> <mat-icon
                    class="material-icons">warning</mat-icon>{{'LABEL.WARNING_APPROVAL_OVER' | translate}}</div>
            <div class="card-title">
                <div *ngIf="(!(order==null))"><b>{{order.code}}.{{order.version}} - {{order.note}}</b>
                    <br><b>{{'LABEL.BRANCH' | translate }}: {{currentBranch?.code}} ({{currentBranch?.codCountry}})</b>
                </div>
            </div>
            <div class="card-title">
                <div *ngIf="rapports.length != 0">
                    <b>{{'LABEL.SEGNALAZIONI' | translate }}:</b>
                    <ul>
                        <li *ngFor="let rapport of rapportsCount() | keyvalue">
                            {{labelRapport(rapport?.key) | translate}}: {{rapport?.value}}
                        </li>
                    </ul>
                </div>
            </div>

            <div class="card-title boxAcconto" [ngClass]="downPaymentCheckStatus ? 'boxAccontoGreen' : 'boxAccontoRed'"
                *ngIf="downPaymentCheckActiveControl && checkComponent('downPaymentCheck')">
                <div>
                    <b>{{'LABEL.STATOACCONTO' | translate }}:</b><br>
                    <p>
                        {{'LABEL.PrimoAccontoAtteso' | translate }}:
                        <b>{{percentageCollectedFromFirstStep}}%</b><br>
                        {{'LABEL.IncassatoAttuale' | translate }}: <b>{{currentDownPaymentPercentage}}%</b>
                    </p>
                </div>
            </div>

            <div class="card-title boxCheckAndChangePaymentMethod"
                *ngIf="checkComponent('checkAndChangePaymentMethod')">
                <div>
                    <b>{{'LABEL.Attenzione' | translate }}!</b><br>
                    <p class="noMargin">
                        {{'LABEL.CHECK_PAYMENT_METHOD_MESSAGE' | translate }}<br>
                        {{'LABEL.IN_THIS_PHASE_POSSIBLE' | translate }}:<br>
                        - {{'LABEL.VERIFY_MODIFY_PAYMENT_METHOD' | translate }}.<br>
                        - {{'LABEL.ADD_CUSTOM_PAYMENT_METHOD' | translate }}.
                    </p>
                </div>
            </div>

            <div class="card-title">
                <div *ngIf="childrenPractice.length != 0">
                    <b>{{'LABEL.PRATICACOLLEGATA' | translate }}:</b>
                    <ul>
                        <li class="practiceLink" *ngFor="let child of childrenPractice"
                            (click)="navigateToTargetPractice(child.code)">
                            {{child.code}} ({{'TYPOLOGIESRELATIONSHIPSBETWEENPRACTICES.' + child.type | translate }})
                        </li>
                    </ul>
                </div>
                <div *ngIf="mainPractice.length != 0">
                    <b>{{'LABEL.PRATICAPRINCIPALE' | translate }}:</b>
                    <ul>
                        <li class="practiceLink" *ngFor="let main of mainPractice"
                            (click)="navigateToTargetPractice(main.code)">
                            {{main.code}}
                        </li>
                    </ul>
                </div>
            </div>
            <div *ngIf="(!(order==null))" class="card-title">
                <div
                    *ngIf="(!(order == null)) && (!(order.OPRel == null)) && (order.OPRel.length > 0) && (!(order.OPRel[0].codeOldSystem == null))">
                    {{'LABEL.CODE_OLD_SYSTEM' | translate}}: <b>{{order.OPRel[0].codeOldSystem}}</b></div>
            </div>
            <div *ngIf="(!(order == null) && order.isSalCento==true)" class="card-title">
                <mat-icon class="material-icons">warning</mat-icon><b>SAL 100</b>
            </div>
        </div>
    </div>
    <div class="buttons-right mar-top-icons">

        <!-- COMPONENTE BOTTONE CAMBIO STATE -->
        <app-practice-state-migration [form]="orderFormGroup" *ngIf="practice && documents" [practice]="practice"
            [components]="components"></app-practice-state-migration>

        <!-- COMPONENTE BOTTONE APERTURA RECLAMO -->
        <app-practice-button-complaint-opening [form]="orderFormGroup" *ngIf="practice && documents"
            [practice]="practice" [components]="components"></app-practice-button-complaint-opening>

        <!-- COMPONENTE BOTTONE CONVENZIONE -->
        <div>
            <button *ngIf="checkAddedConvention()" matTooltip="Add Convention" type="button"
                class="my-bounce btn addConventionButton mx-2" (click)="openAddConventionModal()">
                {{ 'LABEL.addConvention' | translate }}
            </button>
        </div>

        <!-- COMPONENTE COLLEGA NUOVA PRATICA -->
        <div *ngIf="checkComponent('connect_a_new_practice')">
            <button matTooltip="Connect a New Practice" type="button"
                class="my-bounce btn connectNewPracticeButton mx-2" (click)="openConnectNewPracticeModal()">
                {{ 'LABEL.connectNewPractice' | translate }}
            </button>
        </div>

        <!-- COMPONENTE BOTTONE CAMBIA STATO -->
        <app-change-state-button [form]="orderFormGroup" *ngIf="practice && documents" [practice]="practice"
            [costoVenduto]="getCostoVenduto()" [components]="components" [order]="order"
            [paymentMethod]="getCurrentOriginalPaymentMethod()"></app-change-state-button>

        <!-- COMPONENTE BOTTONE SBLOCCA ACCONTO -->
        <app-change-single-state-button [form]="orderFormGroup" *ngIf="practice && documents && components"
            [practice]="practice" [components]="components" [order]="order"></app-change-single-state-button>

        <!-- COMPONENTE BOTTONI -->
        <app-practice-action-buttons *ngIf="orderFormGroup && components" [components]="components"
            [form]="orderFormGroup" [documents]="documents"></app-practice-action-buttons>

    </div>
    <br>
    <mat-stepper class="example-stepper" [orientation]="(stepperOrientation | async)!"
        (selectionChange)="selectionChangeStepper($event)" #stepper>
        <mat-step [stepControl]="buildingFormGroup" label="{{'LABEL.BUILDING' | translate}}" state="checked"
            #first_step>
            <ng-container *ngIf="stepper.selected == null || stepper.selected == first_step">
                <form [formGroup]="buildingFormGroup" class="myform">
                    <h3>{{'LABEL.Edificio' | translate }}</h3>
                    <h4 *ngIf="(buildingFormGroup.controls['building'] == null) || !(buildingFormGroup.controls['building'].value?.id > 0)"
                        style="color:red;">{{'LABEL.NessunEdificioSelezionato' | translate }}</h4>
                    <table
                        *ngIf="!(buildingFormGroup.controls['building'] == null) && buildingFormGroup.controls['building'].value?.id > 0"
                        class="container">
                        <tbody>
                            <tr>
                                <th style="width:30%;">{{'LABEL.Codice' | translate }}</th>
                                <td style="width:52%;">{{ buildingFormGroup.controls['building'].value?.id }}</td>
                                <td style="width:6%;">
                                    <span [matTooltip]="translate.instant('LABEL.Vedi')"
                                        (click)="clickEdificio( buildingFormGroup.controls['building'].value?.id)"><i
                                            class="my-bounce material-icons icsave">travel_explore</i></span>
                                </td>
                                <td style="width:6%;">
                                    <span [matTooltip]="translate.instant('LABEL.CompilaRelazioni')"
                                        (click)="compileRelations()"><i
                                            class="my-bounce material-icons icsave">file_upload</i></span>
                                </td>

                            </tr>
                            <tr>
                                <th style="width:30%;">{{'LABEL.SEDERIF' | translate}}</th>
                                <td style="width:52%;">{{ buildingFormGroup.controls['building'].value?.company }}</td>
                                <td style="width:6%;"></td>
                                <td style="width:6%;"></td>
                                <td style="width:6%;"></td>
                            </tr>
                            <tr>
                                <th style="width:30%;">{{'LABEL.Nome' | translate}}</th>
                                <td style="width:52%;">{{ buildingFormGroup.controls['building'].value?.name }}</td>
                                <td style="width:6%;"></td>
                                <td style="width:6%;"></td>
                                <td style="width:6%;"></td>
                            </tr>
                            <tr>
                                <th style="width:30%;">{{'LABEL.Tipo' | translate}}</th>
                                <td style="width:52%;">{{ 'LABEL.'+ buildingFormGroup.controls['building'].value?.type |
                                    translate }}</td>
                                <td style="width:6%;"></td>
                                <td style="width:6%;"></td>
                                <td style="width:6%;"></td>
                            </tr>
                            <tr>
                                <th style="width:30%;">{{'LABEL.ADDRESS' | translate}}</th>
                                <td style="width:58%;">{{ buildingFormGroup.controls['building'].value?.streetName + ' '
                                    +
                                    buildingFormGroup.controls['building'].value?.streetNumber + ', ' +
                                    buildingFormGroup.controls['building'].value?.city + ' ' +
                                    buildingFormGroup.controls['building'].value?.zip + ' (' +
                                    buildingFormGroup.controls['building'].value?.province + ') ' +
                                    buildingFormGroup.controls['building'].value?.state }}</td>
                                <td style="width:6%;"></td>
                                <td style="width:6%;"></td>
                            </tr>
                        </tbody>
                    </table>
                </form>
                <div class="mrg-com-cont">
                    <mat-expansion-panel [matBadge]="getNumberDocumentsBuilding()">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <b>{{'LABEL.Documenti' | translate}}</b>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div
                            *ngIf="!(buildingFormGroup.controls['building'] == null) && !(buildingFormGroup.controls['building'].value == null) && !(buildingFormGroup.controls['building'].value.documents == null)">
                            <div *ngFor="let document of requestDocuments">

                                <div *ngIf="!(document == null)" class="mycard">
                                    <div>
                                        <span style="font-size: 16px;"><b>{{document.name}}</b> <br></span>
                                        <span *ngIf="!(document.typeName == null)"
                                            matTooltip="{{'FILE-UPLOAD.DOCUMENT-TYPE' | translate}}"
                                            style="font-size: 12px;"><b>{{'LABEL.' + document.typeName!.uiLabel |
                                                translate}}</b></span>
                                        <span *ngIf="(document.typeName == null)"
                                            matTooltip="{{'FILE-UPLOAD.DOCUMENT-TYPE' | translate}}"
                                            style="font-size: 12px;"><b>{{'LABEL.NULL_DOCUMENT_TYPE' |
                                                translate}}</b></span>
                                    </div>
                                    <div class="d-flex">
                                        <a class="btn btn-primary btn-sm me-3 text-dark"
                                            (click)="downloadDocument(document)">{{ 'FILE-UPLOAD.DOWNLOAD' |
                                            translate}}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </div>
                <div class="mrg-com-cont">
                    <mat-expansion-panel [matBadge]="getNumberSurveys()">
                        <mat-expansion-panel-header>
                            <mat-panel-title>
                                <b>{{'LABEL.Questionari' | translate}}</b>
                            </mat-panel-title>
                        </mat-expansion-panel-header>
                        <div
                            *ngIf="!(buildingFormGroup.controls['building'] == null) && !(buildingFormGroup.controls['building'].value == null) && !(buildingFormGroup.controls['building'].value.surveys == null)">
                            <div *ngFor="let survey of buildingFormGroup.controls['building'].value.surveys">
                                <div class="mycard">
                                    {{survey.surveyMasterOrigin.name}}&nbsp;{{'LABEL.del' |
                                    translate}}&nbsp;<b>{{survey.updatedAt | date:'short'}}</b>
                                    <br /><br />
                                    <div *ngFor="let a of survey.answers">
                                        {{a.question.text}}:&nbsp;<b>{{a.value}}</b>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </div>
                <div>
                    <button style="background-color:transparent;" type="button" class="btn btn-primary" matStepperNext>
                        <mat-icon class="material-icons" style="color:#293683;">arrow_forward</mat-icon>
                    </button>
                </div>
            </ng-container>
        </mat-step>
        <mat-step [stepControl]="subjectFormGroup" label="{{'LABEL.SUBJECTS' | translate}}" state="checked"
            #second_step>
            <ng-container *ngIf="stepper.selected == null || stepper.selected == second_step">
                <h3>{{ 'LABEL.SUBJECTS' | translate }}</h3>
                <h4
                    *ngIf="!(subjectFormGroup.controls['subject'].value?.id > 0) && !(condominiumFormGroup.controls['condominium'].value?.id > 0) && !(adminFormGroup.controls['admin'].value?.id > 0) ">
                    {{ 'ORDERS.NO_OBJ_SEL' | translate }}</h4>

                <table *ngIf="condominiumFormGroup.controls['condominium'].value?.id > 0" class="container">
                    <tbody>
                        <tr>
                            <th style="width:30%;">{{'LABEL.CODE' | translate}}</th>
                            <td style="width:40%;">{{ condominiumFormGroup.controls['condominium'].value?.id }}</td>
                            <td style="width:6%;">
                                <span [matTooltip]="translate.instant('LABEL.Vedi')"
                                    (click)="clickCondominio(condominiumFormGroup.controls['condominium'].value?.id)"><i
                                        class="my-bounce material-icons icsave">travel_explore</i></span>
                            </td>

                        </tr>
                        <tr>
                            <th style="width:30%;">{{'LABEL.CODE' | translate}} Delta</th>
                            <td style="width:40%;">{{ condominiumFormGroup.controls['condominium'].value?.sysCodeDelta
                                }}
                            </td>
                            <td style="width:6%;"></td>
                            <td style="width:24%;"></td>
                        </tr>
                        <tr>
                            <th style="width:30%;">{{'LABEL.SEDERIF' | translate}}</th>
                            <td style="width:40%;">{{ condominiumFormGroup.controls['condominium'].value?.company }}
                            </td>
                            <td style="width:6%;"></td>
                            <td style="width:24%;"></td>
                        </tr>
                        <tr>
                            <th style="width:30%;">{{'LABEL.Nome' | translate}}</th>
                            <td style="width:40%;">{{ condominiumFormGroup.controls['condominium'].value?.name }}</td>
                            <td style="width:6%;"></td>
                            <td style="width:24%;"></td>
                        </tr>
                        <tr>
                            <th style="width:30%;">{{'LABEL.Tipo' | translate}}</th>
                            <td style="width:40%;"><b>{{ condominiumFormGroup.controls['condominium'].value?.type }}</b>
                            </td>
                            <td style="width:6%;"></td>
                            <td style="width:24%;"></td>
                        </tr>
                        <tr>
                            <th style="width:30%;">{{'LABEL.PHONE' | translate}} 1</th>
                            <td style="width:40%;">{{ condominiumFormGroup.controls['condominium'].value?.telephone1 }}
                            </td>
                            <td style="width:6%;"></td>
                            <td style="width:24%;"></td>
                        </tr>
                        <tr>
                            <th style="width:30%;">{{'LABEL.PHONE' | translate}} 2</th>
                            <td style="width:40%;">{{ condominiumFormGroup.controls['condominium'].value?.telephone2 }}
                            </td>
                            <td style="width:6%;"></td>
                            <td style="width:24%;"></td>
                        </tr>
                    </tbody>
                </table>
                <hr *ngIf="condominiumFormGroup.controls['condominium'].value?.id > 0">
                <table *ngIf="subjectFormGroup.controls['subject'].value?.id > 0" class="container">
                    <tbody>
                        <tr>
                            <th style="width:30%;">{{'LABEL.CODE' | translate}}</th>
                            <td style="width:40%;">{{ subjectFormGroup.controls['subject'].value?.id }}</td>
                            <td style="width:6%;">
                                <span [matTooltip]="translate.instant('LABEL.Vedi')"
                                    (click)="clickSoggetto(subjectFormGroup.controls['subject'].value?.id)"><i
                                        class="my-bounce material-icons icsave">travel_explore</i></span>
                            </td>

                        </tr>
                        <tr>
                            <th style="width:30%;">{{'LABEL.CODE' | translate}} Delta</th>
                            <td style="width:40%;">{{ subjectFormGroup.controls['subject'].value?.sysCodeDelta }}</td>
                            <td style="width:6%;"></td>
                            <td style="width:24%;"></td>
                        </tr>
                        <tr>
                            <th style="width:30%;">{{'LABEL.SEDERIF' | translate}}</th>
                            <td style="width:40%;">{{ subjectFormGroup.controls['subject'].value?.company }}</td>
                            <td style="width:6%;"></td>
                            <td style="width:24%;"></td>
                        </tr>
                        <tr>
                            <th style="width:30%;">{{'LABEL.Nome' | translate}}</th>
                            <td style="width:40%;">
                                {{
                                (subjectFormGroup.controls['subject'].value?.name || '') + ' ' +
                                (subjectFormGroup.controls['subject'].value?.surname || '')
                                }}
                            </td>
                            <td style="width:6%;"></td>
                            <td style="width:24%;"></td>
                        </tr>
                        <tr>
                            <th style="width:30%;">{{'LABEL.Tipo' | translate}}</th>
                            <td style="width:40%;"><b>{{ subjectFormGroup.controls['subject'].value?.type }}</b></td>
                            <td style="width:6%;"></td>
                            <td style="width:24%;"></td>
                        </tr>
                        <tr>
                            <th style="width:30%;">{{'LABEL.PHONE' | translate}} 1</th>
                            <td style="width:40%;">{{ subjectFormGroup.controls['subject'].value?.telephone1 }}</td>
                            <td style="width:6%;"></td>
                            <td style="width:24%;"></td>
                        </tr>
                        <tr>
                            <th style="width:30%;">{{'LABEL.PHONE' | translate}} 2</th>
                            <td style="width:40%;">{{ subjectFormGroup.controls['subject'].value?.telephone2 }}</td>
                            <td style="width:6%;"></td>
                            <td style="width:24%;"></td>
                        </tr>
                        <tr>
                            <th style="width:30%;">{{'LABEL.EMAIL' | translate}}</th>
                            <td style="width:40%;">{{ subjectFormGroup.controls['subject'].value?.email }}</td>
                            <td style="width:6%;"></td>
                            <td style="width:24%;">
                                <form [formGroup]="subjectFormGroup" *ngIf="!interfaceChangesForDubai()">
                                    <mat-checkbox class="cb-margin" formControlName="isSigning">
                                        {{'LABEL.FirmaElettronica' | translate }}</mat-checkbox>
                                </form>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <hr *ngIf="subjectFormGroup.controls['subject'].value?.id > 0">
                <table *ngIf="adminFormGroup.controls['admin'].value?.id > 0" class="container">
                    <tbody>
                        <tr>
                            <th style="width:30%;">{{'LABEL.CODE' | translate}}</th>
                            <td style="width:40%;">{{ adminFormGroup.controls['admin'].value?.id }}</td>

                        </tr>
                        <tr>
                            <th style="width:30%;">{{'LABEL.CODE' | translate}} Delta</th>
                            <td style="width:40%;">{{ adminFormGroup.controls['admin'].value?.sysCodeDelta }}</td>
                            <td style="width:30%;"></td>
                        </tr>
                        <tr>
                            <th style="width:30%;">{{'LABEL.SEDERIF' | translate}}</th>
                            <td style="width:40%;">{{ adminFormGroup.controls['admin'].value?.company }}</td>
                            <td style="width:30%;"></td>
                        </tr>
                        <tr>
                            <th style="width:30%;">{{'LABEL.Nome' | translate}}</th>
                            <td style="width:40%;">{{ adminFormGroup.controls['admin'].value?.name }}</td>
                            <td style="width:30%;"></td>
                        </tr>
                        <tr>
                            <th style="width:30%;">{{'LABEL.Tipo' | translate}}</th>
                            <td style="width:40%;"><b>{{ adminFormGroup.controls['admin'].value?.type }}</b></td>
                            <td style="width:30%;"></td>
                        </tr>
                        <tr>
                            <th style="width:30%;">{{'LABEL.PHONE' | translate}} 1</th>
                            <td style="width:40%;">{{ adminFormGroup.controls['admin'].value?.telephone1 }}</td>
                            <td style="width:30%;"></td>
                        </tr>
                        <tr>
                            <th style="width:30%;">{{'LABEL.PHONE' | translate}} 2</th>
                            <td style="width:40%;">{{ adminFormGroup.controls['admin'].value?.telephone2 }}</td>
                            <td style="width:30%;"></td>
                        </tr>
                        <tr>
                            <th style="width:30%;">{{'LABEL.EMAIL' | translate}}</th>
                            <td style="width:40%;">{{ adminFormGroup.controls['admin'].value?.email }}</td>
                            <td style="width:30%;">
                                <form [formGroup]="adminFormGroup">
                                    <mat-checkbox class="cb-margin" formControlName="isSigning"
                                        *ngIf="!interfaceChangesForDubai()">
                                        {{'LABEL.FirmaElettronica' | translate }}</mat-checkbox>
                                </form>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <!-- COMPONENTE AGGIUNGI SOGGETTO TIPIZZATO -->
                <app-add-subject-to-practice-button *ngIf="practice?.id && orderFormGroup && components"
                    [components]="components" [form]="orderFormGroup"></app-add-subject-to-practice-button>

                <div>
                    <button style="background-color:transparent;" type="button" class="btn btn-primary"
                        matStepperPrevious>
                        <mat-icon class="material-icons" style="color:#293683;">arrow_back</mat-icon>
                    </button>
                    <button style="background-color:transparent;" type="button" class="btn btn-primary" matStepperNext>
                        <mat-icon class="material-icons" style="color:#293683;">arrow_forward</mat-icon>
                    </button>
                </div>
            </ng-container>
        </mat-step>
        <mat-step [stepControl]="orderFormGroup" label="{{'LABEL.PREVENTIVI' | translate}}" state="checked" #third_step>
            <ng-container>
                <span *ngFor="let v of versions">

                    <mat-card *ngIf="(v.version == actualversion)" class="mrg-com-cont bck-sel">
                        <mat-card-title>
                            <span style="display: flex; flex-direction: row; justify-content:space-between !important;">
                                <span class="card-title">
                                    <span class="material-icons">check_circle</span>&nbsp;
                                    <span> {{ order.code }}.{{ order.version }}</span>&nbsp;
                                    <span *ngIf="!(v.name == null) && !(v.name == 'null')">&nbsp;-&nbsp;{{ v.name
                                        }}</span>
                                </span>
                                <span class="card-title-rigth">
                                    <div [matTooltip]="getToolTipProjectCosts()" class="bt-consegna"
                                        (click)="openModalProjectCosts()">
                                        <span class="material-icons">handyman</span>
                                    </div>
                                    <div [matTooltip]="getToolTipManpowerHours()" class="bt-consegna"
                                        (click)="openModalManpowerHours()">
                                        <span class="material-icons">engineering</span>
                                    </div>
                                    <div [matTooltip]="getToolTipPrint()" class="bt-consegna"
                                        *ngIf="!interfaceChangesForDubai() || isInfrastructurePractice()"
                                        (click)="downloadPreventivo(order)">
                                        <span class="material-icons">print</span>
                                    </div>
                                </span>
                            </span>
                        </mat-card-title>
                    </mat-card>
                </span>
                <mat-expansion-panel *ngIf="!(versions == null) && (versions.length > 1)"
                    [matBadge]="versions.length -1">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            {{'LABEL.Versioni' | translate}}
                        </mat-panel-title>
                    </mat-expansion-panel-header>

                    <span *ngFor="let v of versions">
                        <mat-expansion-panel *ngIf="!(v.version == actualversion)" class="mrg-com-cont icnc">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <span
                                        style="display: flex; flex-direction: row; justify-content:space-between !important; width:100%;">
                                        <div
                                            style="display: flex; flex-direction: row; justify-content:flex-start !important;">
                                            <span class="card-title hvA">
                                                <span class="material-icons">done</span>
                                                <span> {{ order.code }}.{{ v.version }}</span>&nbsp;
                                                <span *ngIf="!(v.name == null) && !(v.name == 'null')">&nbsp;-&nbsp;{{
                                                    v.name
                                                    }}&nbsp;</span>
                                            </span>
                                        </div>
                                    </span>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div [innerHTML]="getDetail(v)"></div>
                        </mat-expansion-panel>

                    </span>

                </mat-expansion-panel>
                <form [formGroup]="orderFormGroup">
                    <div class="com-cont">
                        <!-- DATI GENERALI -->
                        <mat-card class="mrg-com-cont">
                            <mat-card-title class="card-title">
                                <span class="material-icons">assignment</span>&nbsp;
                                <span> {{ 'LABEL.GENERAL_DATA' | translate }}</span>
                                <div *ngIf="!(requests == null) && (requests.length > 0) && !(requests[0] == null)"
                                    [matTooltip]="getToolTipRequest(requests[0])">
                                    <div class="little-text">
                                        &nbsp;{{ 'REQUEST.REQUEST' | translate
                                        }}&nbsp;<b>{{requests[0].id}}</b>&nbsp;-&nbsp;{{requests[0].assignmentOperator}}
                                    </div>
                                </div>
                            </mat-card-title>
                            <mat-card-content>
                                <div class="form-row">

                                    <div class="card-row positionRelative">
                                        <div class="mrg-com-cont full boxSede">
                                            <span class="boxSedeLabel">{{'REQUEST.COMPANY' | translate }} *</span><br>
                                            <span
                                                class="boxSedeValue">{{orderFormGroup?.get('sede')?.value?.name}}</span>
                                        </div>

                                        <app-practice-change-company *ngIf="orderFormGroup" [form]="orderFormGroup"
                                            [companies]="companies"></app-practice-change-company>
                                    </div>

                                    <div class="card-row">
                                        <span class="mrg-com-cont-sm full positionRelative"
                                            *ngIf="(!(resourcesRespComm == null) && (resourcesRespComm.length > 0))">

                                            <app-practice-change-sales-manager *ngIf="orderFormGroup && components"
                                                [form]="orderFormGroup" [components]="components"
                                                [respComm]="resourcesRespComm"></app-practice-change-sales-manager>

                                            <app-select-search appearance="fill" [noUsers]="!editableEstimate()"
                                                formControlName="responsabileCommerciale" [label]="getLabelResp()"
                                                [items]="resourcesRespComm" viewField="name">
                                            </app-select-search>
                                        </span>
                                        <span class="mrg-com-cont-sm full"
                                            *ngIf="(!(resourcesCoord == null) && (resourcesCoord.length > 0))">
                                            <app-select-search appearance="fill" formControlName="coordinatore"
                                                [noUsers]="!editableEstimate()" [label]="getLabelCoord()"
                                                [items]="resourcesCoord" viewField="name">
                                            </app-select-search>
                                        </span>
                                    </div>

                                    <div class="card-row">
                                        <mat-form-field class="mrg-com-cont full" appearance="fill">
                                            <mat-label>{{'LABEL.NOTE' | translate}}</mat-label>
                                            <textarea matInput formControlName="note" [readonly]="!editableEstimate()">
                                        </textarea>
                                        </mat-form-field>
                                    </div>

                                    <div class="card-row">

                                        <span class="mrg-com-cont full" appearance="fill"
                                            *ngIf="!interfaceChangesForDubai() && !isFRAndMCLob()">
                                            <mat-form-field class="example-full-width dis">
                                                <mat-label>{{'LABEL.OneriSicurezza' | translate}}</mat-label>
                                                <input matInput formControlName="oneriSicurezza" readonly>
                                            </mat-form-field>

                                        </span>

                                        <span class="mrg-com-cont full" appearance="fill"
                                            *ngIf="!interfaceChangesForDubai()">
                                            <mat-slide-toggle (change)="changeFinancingToggleActivation($event)"
                                                color="primary" *ngIf="financingToggleActivation"
                                                formControlName="financingSectionActivation">Abilita
                                                Finanziamento</mat-slide-toggle>
                                        </span>

                                    </div>

                                </div>
                            </mat-card-content>
                        </mat-card>

                        <!-- FINANZIAMNENTO -->
                        <mat-expansion-panel class="mrg-com-cont" *ngIf="theFundingHasBeenActivated()">
                            <mat-expansion-panel-header>
                                <mat-panel-title>
                                    <span class="material-icons">account_balance</span>&nbsp;
                                    <span> {{ 'LABEL.FINANZIAMENTO' | translate }}</span>
                                </mat-panel-title>
                            </mat-expansion-panel-header>
                            <div class="form-row">

                                <div class="card-row">
                                    <p>1. Scegli la <strong>tipologia di finanziamento</strong>:
                                    </p>
                                </div>

                                <div class="card-row">

                                    <mat-form-field class="mrg-com-cont-md" appearance="fill">
                                        <mat-label>{{'LABEL.TipologiaFinanziamento' | translate }}</mat-label>
                                        <mat-select (selectionChange)="changeFundingTypes()"
                                            formControlName="fundingType">
                                            <mat-option *ngFor="let type of fundingTypes" [value]="type.code">
                                                {{type.label}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div *ngIf="orderFormGroup.controls['fundingType'].value == 'finanziamentoTasso0'">


                                    <div class="card-row">
                                        <p>2. Indica il <strong>numero di rate</strong>,
                                            il <strong>numero di condomini
                                                totale</strong>, il <strong>numero di condomini che aderisce al
                                                finanziamento</strong> e il <strong>totale millesimi di chi
                                                finanzia</strong>:
                                        </p>
                                    </div>

                                    <div class="card-row">

                                        <mat-form-field class="mrg-com-cont-md" appearance="fill">
                                            <mat-label>{{'LABEL.NumeroRate' | translate }}</mat-label>
                                            <input type="text" matInput [formControl]="fundingControl"
                                                [matAutocomplete]="fundingAutocomplete"
                                                [placeholder]="'LABEL.NumeroRate' | translate">
                                            <button mat-icon-button matSuffix *ngIf="fundingControl.value"
                                                (click)="clearFundingSelection()" [attr.aria-label]="'Clear selection'">
                                                <mat-icon>clear</mat-icon>
                                            </button>
                                            <mat-autocomplete #fundingAutocomplete="matAutocomplete"
                                                [displayWith]="displayFundingFn"
                                                (optionSelected)="onFundingSelected($event)">
                                                <mat-option *ngFor="let funding of filteredFundings | async"
                                                    [value]="funding" [disabled]="funding.disabled">
                                                    {{funding.label}}{{getIva(funding)}} <span *ngIf="funding.type">-
                                                        {{capitalizeFirstLetter(funding?.type)}} </span>-
                                                    {{funding.source}}
                                                </mat-option>
                                            </mat-autocomplete>
                                        </mat-form-field>

                                        <mat-form-field class="mrg-com-cont-md" appearance="fill"
                                            *ngIf="checkManagementOfFinancingIncrease()">
                                            <mat-label>{{'LABEL.IncrementoFinanziamento' | translate }}</mat-label>
                                            <mat-select formControlName="financingIncreaseValue"
                                                (selectionChange)="changefinancingIncreaseValue($event)">
                                                <mat-option
                                                    [selected]="increase.value == orderFormGroup.controls['financingIncreaseValue'].value"
                                                    *ngFor="let increase of listOfFinancingIncreases"
                                                    [value]="increase.value">
                                                    {{increase.value*100}}%
                                                </mat-option>
                                            </mat-select>
                                            <mat-hint *ngIf="checkSystemFundingIncreases()" style="color:red;">
                                                Incremento modificato manualmente (<strong>Default:
                                                    {{systemFundingIncreases*100}}%</strong>)
                                            </mat-hint>
                                        </mat-form-field>

                                    </div>

                                    <div class="card-row">

                                        <mat-form-field class="mrg-com-cont" appearance="fill">
                                            <mat-label>{{'LABEL.numberOfCondominiums' | translate }}</mat-label>
                                            <input type="number" matInput formControlName="numberOfCondominiums"
                                                (focusout)="setFinanziamento()">
                                        </mat-form-field>

                                        <mat-form-field class="mrg-com-cont" appearance="fill">
                                            <mat-label>{{'LABEL.numberOfCondominiumsThatFinance' | translate
                                                }}</mat-label>
                                            <input type="number" matInput
                                                formControlName="numberOfCondominiumsThatFinance"
                                                (focusout)="setFinanziamento()">
                                        </mat-form-field>

                                        <mat-form-field class="mrg-com-cont" appearance="fill">
                                            <mat-label>{{'LABEL.totalThousandthsOfTheFinancing' | translate
                                                }}</mat-label>
                                            <input type="number" min="0" max="1000" matInput
                                                formControlName="totalThousandthsOfTheFinancing"
                                                (focusout)="setFinanziamento()">
                                        </mat-form-field>

                                    </div>

                                    <div class="card-row">
                                        <div>
                                            <p style="margin-bottom:3px;">3. Inserisci la <strong>percentuale sul
                                                    totale</strong> che si vuole finanziare oppure <strong>l'anticipo in
                                                    %</strong>:</p>
                                            <p style="color:red;display:block;" *ngIf="getMaximumFundableMultiplier()">
                                                La
                                                percentuale
                                                massima finanziabile è:
                                                <strong>{{getMaximumFundableMultiplier()}}%</strong>
                                            </p>
                                            <p style="color:red;display:block;"
                                                *ngIf="validationBetweenFinancingPercentageAndTotalThousandths()">
                                                <strong>Attenzione:la percentuale di finanziamento non può essere
                                                    superiore al totale di millesimi di chi finanzia.</strong>
                                            </p>
                                        </div>

                                    </div>

                                    <div class="card-row">

                                        <mat-form-field class="mrg-com-cont" appearance="fill"
                                            [ngClass]="{'errorMaximumFinancingInstallment': validationBetweenFinancingPercentageAndTotalThousandths()}">
                                            <mat-label>{{'LABEL.percentageFinancing' | translate }}</mat-label>
                                            <input type="number" matInput formControlName="percentageFinancing" min="0"
                                                [max]="getMaximumFundableMultiplier()"
                                                (focusout)="setFinanziamento('percentageFinancing')">
                                        </mat-form-field>

                                        <mat-form-field class="mrg-com-cont" appearance="fill">
                                            <mat-label>{{'LABEL.advanceFinancing' | translate }}</mat-label>
                                            <input type="number" matInput formControlName="advanceFinancing"
                                                [min]="getMinimumAdvance()" max="100"
                                                (focusout)="setFinanziamento('advanceFinancing')">
                                        </mat-form-field>

                                        <mat-form-field class="mrg-com-cont" appearance="fill">
                                            <mat-label>{{'LABEL.advanceFinancingWithVAT' | translate }}</mat-label>
                                            <input [readonly]="true" type="number" matInput
                                                formControlName="advanceFinancingWithVAT"
                                                (focusout)="setFinanziamento('advanceFinancingWithVAT')">
                                        </mat-form-field>

                                        <!--
                                        <mat-form-field class="mrg-com-cont" appearance="fill">
                                            <mat-label>{{'LABEL.percentageFinancingWithVAT' | translate }}</mat-label>
                                            <input type="number" matInput formControlName="percentageFinancingWithVAT"
                                                (focusout)="setFinanziamento('percentageFinancingWithVAT')">
                                        </mat-form-field>
                                        -->

                                    </div>

                                    <hr style="width:100%">

                                    <div class="card-row">
                                        <div>
                                            <p style="margin-bottom:3px;">4. Esito della configurazione del
                                                finanziamento:</p>
                                            <p style="color:red;display:block;"
                                                *ngIf="financedByBancaSellaWithVATValidationMessage()"
                                                [innerHTML]="financedByBancaSellaWithVATValidationMessage()"></p>
                                        </div>
                                    </div>

                                    <div class="card-row">

                                        <mat-form-field class="mrg-com-cont" appearance="fill"
                                            [ngClass]="{'errorfinancedByBancaSellaWithVAT': financedByBancaSellaWithVATValidation()}">
                                            <mat-label>{{'LABEL.financedByBancaSellaWithVAT' | translate }}</mat-label>
                                            <input type="number" matInput formControlName="fundedValue"
                                                [readonly]="true">
                                        </mat-form-field>

                                        <mat-form-field class="mrg-com-cont" appearance="fill">
                                            <mat-label>{{'LABEL.bankTaxForFinancing' | translate }}</mat-label>
                                            <input type="number" matInput formControlName="bankTaxForFinancing"
                                                [readonly]="true">
                                        </mat-form-field>

                                        <mat-form-field class="mrg-com-cont" appearance="fill">
                                            <mat-label>{{'LABEL.maximumFinancingInstallmentValue' | translate
                                                }}</mat-label>
                                            <input type="number" matInput
                                                formControlName="maximumFinancingInstallmentValue" [readonly]="true">
                                        </mat-form-field>

                                    </div>

                                    <div class="card-row">

                                        <mat-form-field class="mrg-com-cont-md" appearance="fill">
                                            <mat-label>{{'LABEL.advancePaymentWithVATForCondominiumsParticipatingInTheFinancing'
                                                | translate }}</mat-label>
                                            <input type="number" matInput
                                                formControlName="advancePaymentWithVATForCondominiumsParticipatingInTheFinancing"
                                                [readonly]="true">
                                        </mat-form-field>

                                        <mat-form-field class="mrg-com-cont-md" appearance="fill">
                                            <mat-label>{{'LABEL.advancePaymentWithVATForCondominiumsThatDoNotParticipateInTheFinancing'
                                                | translate }}</mat-label>
                                            <input type="number" matInput
                                                formControlName="advancePaymentWithVATForCondominiumsThatDoNotParticipateInTheFinancing"
                                                [readonly]="true">
                                        </mat-form-field>

                                    </div>

                                    <div class="card-row">

                                        <mat-form-field class="mrg-com-cont-md" appearance="fill"
                                            [ngClass]="{'errorMaximumFinancingInstallment': maximumFinancingInstallmentValidation()}">
                                            <mat-label>{{'LABEL.installmentValueCondominium' | translate }}</mat-label>
                                            <input type="number" matInput formControlName="installmentValueCondominium"
                                                [readonly]="true">
                                        </mat-form-field>

                                        <mat-form-field class="mrg-com-cont-md" appearance="fill">
                                            <mat-label>{{'LABEL.totalPayment' | translate }}</mat-label>
                                            <input type="number" matInput formControlName="totalPayment"
                                                [readonly]="true">
                                        </mat-form-field>


                                    </div>

                                    <div class="card-row">
                                        <span class="mrg-com-cont-md">
                                            <mat-form-field class="full-width" appearance="fill"
                                                [ngClass]="{'errorMaximumFinancingInstallment': checkMaximumAmountCanBeFinancedPerCondominiumOwner()}">
                                                <mat-label>{{'LABEL.maximumAmountCanBeFinancedPerCondominium' |
                                                    translate
                                                    }}
                                                </mat-label>
                                                <input type="text" matInput
                                                    formControlName="maximumAmountCanBeFinancedPerCondominiumString"
                                                    [readonly]="true">
                                                <mat-hint>
                                                    Importo massimo finanziabile per singolo condomino <br>(Media
                                                    Importo) =
                                                    10000€
                                                </mat-hint>
                                            </mat-form-field>

                                        </span>

                                        <span class="mrg-com-cont-md boxVendutoConIva">
                                            <span class="boxVendutoConIvaLabel">{{'LABEL.VendutoConIva' |
                                                translate}}</span>
                                            <p class="boxVendutoConIvaValue"><strong>{{getSoldWithVAT() | number:
                                                    '1.2-2'}}</strong></p>
                                        </span>
                                    </div>

                                </div>

                                <div *ngIf="checkFinanziamentoTassoEsposto()">

                                    <div class="card-row">
                                        <p>2. Indica il <strong>numero totale di condomini</strong> e il <strong>numero
                                                di condomini che aderiscono al finanziamento</strong>:
                                        </p>
                                    </div>

                                    <div class="card-row">

                                        <mat-form-field class="mrg-com-cont" appearance="fill">
                                            <mat-label>{{'LABEL.numberOfCondominiums' | translate }}</mat-label>
                                            <input type="number" matInput formControlName="numberOfCondominiums"
                                                (focusout)="resetExposedFinancing()">
                                        </mat-form-field>

                                        <mat-form-field class="mrg-com-cont" appearance="fill">
                                            <mat-label>{{'LABEL.numberOfCondominiumsThatFinance' | translate
                                                }}</mat-label>
                                            <input type="number" matInput
                                                formControlName="numberOfCondominiumsThatFinance"
                                                (focusout)="resetExposedFinancing()">
                                        </mat-form-field>

                                    </div>


                                    <div class="card-row">
                                        <p>3. Indica il valore che si vuole finanziare, l'IVA, il numero di rate e
                                            cliccare su "Calcola":
                                        </p>
                                    </div>

                                    <div class="card-row">

                                        <mat-form-field class="mrg-com-cont" appearance="fill">
                                            <mat-label>{{'LABEL.amountToBeFinancedExposedFinancing' | translate
                                                }}</mat-label>
                                            <input type="number" [max]="getCostoVenduto()" matInput
                                                formControlName="amountToBeFinancedExposedFinancing"
                                                (focusout)="onAmountToBeFinancedExposedFinancingChange($event)">
                                        </mat-form-field>

                                        <mat-form-field class="mrg-com-cont" appearance="fill">
                                            <mat-label>{{'LABEL.vatCodeMultiplier' | translate
                                                }}</mat-label>
                                            <mat-select formControlName="vatCodeMultiplier"
                                                (selectionChange)="resetExposedFinancing()">
                                                <mat-option *ngFor="let vat of listVATS" [value]="vat.value">
                                                    {{vat.label}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>

                                        <mat-form-field class="mrg-com-cont" appearance="fill">
                                            <mat-label>{{'LABEL.numberOfFinancingInstallmentsExposed' | translate
                                                }}</mat-label>
                                            <mat-select formControlName="numberOfFinancingInstallmentsExposed"
                                                [disabled]="checkActivationNumberOfFinancingInstallmentsExposed()">
                                                <mat-option *ngFor="let installment of rate"
                                                    [selected]="installment == orderFormGroup.controls['numberOfFinancingInstallmentsExposed'].value"
                                                    [value]="installment">
                                                    {{installment}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>


                                        <div class="mrg-com-cont" appearance="fill">
                                            <button mat-raised-button color="primary"
                                                [disabled]="checkCalculateButtonActivation()"
                                                (click)="calculateExposedFinancing()">{{'LABEL.Calculate' | translate
                                                }}</button>
                                        </div>


                                    </div>

                                    <hr style="width:100%">

                                    <div class="card-row">
                                        <div>
                                            <p style="margin-bottom:3px;">4. Esito della configurazione del
                                                finanziamento:</p>
                                        </div>
                                    </div>

                                    <div class="card-row">

                                        <mat-form-field class="mrg-com-cont" appearance="fill">
                                            <mat-label>{{'LABEL.singleInstallmentLoanAmountExposed' | translate
                                                }}</mat-label>
                                            <input type="number" matInput
                                                formControlName="singleInstallmentLoanAmountExposed" [readonly]="true">
                                        </mat-form-field>

                                        <mat-form-field class="mrg-com-cont" appearance="fill">
                                            <mat-label>{{'LABEL.tan' | translate }}</mat-label>
                                            <input type="number" matInput formControlName="tan" [readonly]="true">
                                        </mat-form-field>

                                        <mat-form-field class="mrg-com-cont" appearance="fill">
                                            <mat-label>{{'LABEL.taeg' | translate
                                                }}</mat-label>
                                            <input type="number" matInput formControlName="taeg" [readonly]="true">
                                        </mat-form-field>

                                    </div>

                                    <div class="card-row">

                                        <mat-form-field class="mrg-com-cont-md" appearance="fill">
                                            <mat-label>{{'LABEL.advanceFinancing' | translate }}</mat-label>
                                            <input type="number" matInput formControlName="advanceFinancing" min="0"
                                                max="100" [readonly]="true">
                                        </mat-form-field>

                                        <mat-form-field class="mrg-com-cont-md" appearance="fill">
                                            <mat-label>{{'LABEL.advanceFinancingWithVAT' | translate }}</mat-label>
                                            <input type="number" matInput formControlName="advanceFinancingWithVAT"
                                                [readonly]="true">
                                        </mat-form-field>

                                    </div>

                                    <div class="card-row">

                                        <mat-form-field class="mrg-com-cont-md" appearance="fill"
                                            [ngClass]="{'errorMaximumFinancingInstallment': maximumFinancingInstallmentValidation()}">
                                            <mat-label>{{'LABEL.installmentValueCondominium' | translate }}</mat-label>
                                            <input type="number" matInput formControlName="installmentValueCondominium"
                                                [readonly]="true">
                                        </mat-form-field>

                                        <mat-form-field class="mrg-com-cont-md" appearance="fill"
                                            [ngClass]="{'errorMaximumFinancingInstallment': checkMaximumAmountCanBeFinancedPerCondominiumOwnerExposedFinancing()}">
                                            <mat-label>{{'LABEL.maximumAmountCanBeFinancedPerCondominium' | translate
                                                }}</mat-label>
                                            <input type="text" matInput
                                                formControlName="maximumAmountCanBeFinancedPerCondominiumString"
                                                [readonly]="true">
                                        </mat-form-field>

                                    </div>

                                </div>


                            </div>
                        </mat-expansion-panel>

                        <!-- QUESTIONARIO -->
                        <mat-card class="mrg-com-cont" *ngIf="isScheduledMaintenance">
                            <mat-card-title class="card-title">
                                <span class="material-icons">assignment</span>&nbsp;
                                <span> {{ 'LABEL.questionario' | translate }}</span>
                            </mat-card-title>
                            <mat-card-content>
                                <div class="form-row">

                                    <div class="card-row">
                                        <mat-form-field class="mrg-com-cont full" appearance="fill">
                                            <mat-label>{{'LABEL.weCarryOutRoofMaintenance' | translate }}</mat-label>
                                            <mat-select formControlName="weCarryOutRoofMaintenance"
                                                (selectionChange)="onChangeweCarryOutRoofMaintenanceSelect($event)">
                                                <mat-option
                                                    [selected]="weCarryOutRoofMaintenanceResponse.code == orderFormGroup.controls['weCarryOutRoofMaintenance'].value"
                                                    *ngFor="let weCarryOutRoofMaintenanceResponse of weCarryOutRoofMaintenanceResponses"
                                                    [value]="weCarryOutRoofMaintenanceResponse.code">
                                                    {{'LABEL.' + weCarryOutRoofMaintenanceResponse.code | translate }}
                                                </mat-option>
                                            </mat-select>
                                            <mat-hint>{{getWeCarryOutRoofMaintenanceHint()}}</mat-hint>
                                        </mat-form-field>
                                    </div>

                                    <div class="card-row" *ngIf="showTypeOfCoverage()">
                                        <mat-form-field class="mrg-com-cont full" appearance="fill">
                                            <mat-label>{{'LABEL.typeOfCoverage' | translate }}</mat-label>
                                            <mat-select formControlName="typeOfCoverage">
                                                <mat-option
                                                    [selected]="typeOfCoverageResponse.code == orderFormGroup.controls['typeOfCoverage'].value"
                                                    *ngFor="let typeOfCoverageResponse of typeOfCoverageResponses"
                                                    [value]="typeOfCoverageResponse.code">
                                                    {{'LABEL.' + typeOfCoverageResponse.code | translate }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                    <div class="card-row">
                                        <mat-form-field class="mrg-com-cont full" appearance="fill">
                                            <mat-label>{{'LABEL.healthCoverageCoefficient' | translate }}</mat-label>
                                            <mat-select formControlName="healthCoverageCoefficient">
                                                <mat-option
                                                    [selected]="healthCoverageCoefficientResponse.code == orderFormGroup.controls['healthCoverageCoefficient'].value"
                                                    *ngFor="let healthCoverageCoefficientResponse of healthCoverageCoefficientResponses"
                                                    [value]="healthCoverageCoefficientResponse.code">
                                                    {{'LABEL.' + healthCoverageCoefficientResponse.code | translate }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                    <div class="card-row">
                                        <mat-form-field class="mrg-com-cont full" appearance="fill">
                                            <mat-label>{{'LABEL.processingDifficulty' | translate }}</mat-label>
                                            <mat-select formControlName="processingDifficulty" multiple
                                                (selectionChange)="onProcessingDifficultyChange($event)">
                                                <mat-option
                                                    [selected]="processingDifficultyResponse.code == orderFormGroup.controls['processingDifficulty'].value"
                                                    *ngFor="let processingDifficultyResponse of processingDifficultyResponses"
                                                    [value]="processingDifficultyResponse.code"
                                                    [disabled]="processingDifficultyResponse.disabled">
                                                    {{'LABEL.' + processingDifficultyResponse.code | translate }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                </div>
                            </mat-card-content>
                        </mat-card>

                        <!-- LAVORAZIONI -->
                        <mat-card class="mrg-com-cont" *ngIf="showWorkingBox(); else noBoxWorking">
                            <mat-card-title class="card-title row-panel">
                                <span class="row-panel-group-rigth">
                                    <span class="material-icons">engineering</span>&nbsp;
                                    <span> {{ 'ORDERS.LAVORAZIONI' | translate }} ( {{ 'LABEL.PREZZO_NETTO_TOTALE' |
                                        translate }}: {{getRicavoReale() | number: '1.2-2'}} )</span>
                                </span>
                                <button *ngIf="editableEstimate()" aria-label="Aggiungi lavorazione"
                                    style="background-color:transparent;" type="button" class="btn btn-primary"
                                    (click)="addRow(order.rows.length)">
                                    <mat-icon class="material-icons" style="color:#293683;">plus_one</mat-icon>
                                </button>
                            </mat-card-title>
                            <mat-card-content>
                                <span *ngFor="let r of order?.rows; let i = index" [ngClass]="getRowClass(i)">
                                    <mat-card class="card-title row-panel">
                                        <div *ngIf="!(orderFormGroup.controls['macrophases'].value[i]==null)"
                                            class="form-row">
                                            <mat-form-field class="mrg-com-cont" appearance="fill">
                                                <mat-label>{{'LABEL.BRANCH' | translate}}</mat-label>
                                                <mat-select
                                                    [formControl]="orderFormGroup.controls['macrophases'].value[i].controls['branch']"
                                                    (selectionChange)="onChangeBranchesSelect($event)" required>
                                                    <mat-option (onSelectionChange)="onChange('branches',i,$event)"
                                                        *ngFor="let branch of filterBranchesForSelect()"
                                                        [value]="branch" [disabled]="!(branch.isActive == true)">
                                                        {{branch.name}} ({{branch.codCountry}})
                                                    </mat-option>
                                                </mat-select>
                                                <mat-hint
                                                    *ngIf="orderFormGroup.controls['macrophases'].value[i].controls['branch']">
                                                    <b>{{orderFormGroup.controls['macrophases'].value[i].controls['branch']?.value?.name}}</b>
                                                </mat-hint>
                                            </mat-form-field>
                                            <mat-form-field class="mrg-com-cont" appearance="fill">
                                                <mat-label>{{'LABEL.CATEGORY' | translate}}</mat-label>
                                                <mat-select
                                                    [formControl]="orderFormGroup.controls['macrophases'].value[i].controls['category']"
                                                    required>
                                                    <mat-option (onSelectionChange)="onChange('categories',i,$event)"
                                                        *ngFor="let category of filterCategories(orderFormGroup.controls['macrophases'].value[i].controls['branch'].value, i)"
                                                        [value]="category"
                                                        [disabled]="!(category.isActive == true && uniqueCategoryForSolare(orderFormGroup.controls['macrophases'], category.code))">
                                                        {{category.name}}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-hint
                                                    *ngIf="orderFormGroup.controls['macrophases'].value[i].controls['category'].value.id > 0">
                                                    <b>{{orderFormGroup.controls['macrophases'].value[i].controls['category'].value.name}}</b>
                                                </mat-hint>
                                            </mat-form-field>
                                            <mat-form-field class="mrg-com-cont" appearance="fill">
                                                <mat-label>{{'LABEL.MACROPHASE' | translate}}</mat-label>
                                                <mat-select
                                                    [formControl]="orderFormGroup.controls['macrophases'].value[i].controls['macrophase']"
                                                    required>
                                                    <mat-option (onSelectionChange)="onChange('macrophases',i,$event)"
                                                        *ngFor="let mPhase of filterMacroPhases(orderFormGroup.controls['macrophases'].value[i].controls['category'].value, i)"
                                                        [value]="mPhase" [disabled]="!(mPhase.isActive == true)">
                                                        {{mPhase.name}}
                                                    </mat-option>
                                                </mat-select>
                                                <mat-hint
                                                    *ngIf="orderFormGroup.controls['macrophases'].value[i].controls['macrophase'].value.id > 0">
                                                    <b>{{orderFormGroup.controls['macrophases'].value[i].controls['macrophase'].value.name}}</b>
                                                </mat-hint>
                                            </mat-form-field>

                                            <mat-form-field class="mrg-com-cont" appearance="fill"
                                                *ngIf="isMultiservice">
                                                <mat-label>{{'TYPOLOGYSERVICEPASSAGES.title' |
                                                    translate}}</mat-label>
                                                <mat-select
                                                    [formControl]="this.orderFormGroup.controls['macrophases'].value[i].controls['TypologyServicePassageId']">
                                                    <mat-option
                                                        *ngFor="let typologyServicePassage of typologyServicePassages"
                                                        [value]="typologyServicePassage.id">
                                                        {{'TYPOLOGYSERVICEPASSAGES.' +
                                                        typologyServicePassage.code | translate}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>

                                            <mat-form-field *ngIf="creditTransferDisplayCriteria()" class="mrg-com-cont"
                                                appearance="fill">
                                                <mat-label>{{'LABEL.CessioneCredito' | translate}}</mat-label>
                                                <mat-select
                                                    [formControl]="orderFormGroup.controls['macrophases'].value[i].controls['percCredit']">
                                                    <mat-option *ngFor="let taxStep of taxSteps" [value]="taxStep">
                                                        {{taxStep.percStep}}
                                                    </mat-option>
                                                </mat-select>
                                            </mat-form-field>

                                            <span class="block-cb-master">

                                                <span class="block-cb-slave"
                                                    *ngIf="practice.BusinessLineId != 40 && !interfaceChangesForDubai()">
                                                    <mat-checkbox class="cb-margin"
                                                        [formControl]="orderFormGroup.controls['macrophases'].value[i].controls['isNotturno']">
                                                        {{'WORKTYPES.NIGTH' | translate}}</mat-checkbox>
                                                    <mat-checkbox class="cb-margin"
                                                        [formControl]="orderFormGroup.controls['macrophases'].value[i].controls['isTrasferta']">
                                                        {{'WORKTYPES.TRAS' | translate}}</mat-checkbox>
                                                    <mat-checkbox class="cb-margin"
                                                        [formControl]="orderFormGroup.controls['macrophases'].value[i].controls['isFestivo']">
                                                        {{'WORKTYPES.FEST' | translate}}</mat-checkbox>
                                                </span>
                                                <span class="block-cb-slave">
                                                    <mat-form-field *ngIf="isMultiservice || isScheduledMaintenance"
                                                        class="field-row-phase">
                                                        <input matInput type="number" min="1"
                                                            [readonly]="!editableEstimate()"
                                                            [formControl]="this.orderFormGroup.controls['macrophases'].value[i].controls['howMany']"
                                                            placeholder="Numero ripetizioni"
                                                            (ngModelChange)="changeHowMany(i,$event)">
                                                    </mat-form-field>

                                                </span>
                                            </span>


                                            <div class="flex-container boxRowDetails"
                                                *ngIf="!(orderFormGroup.controls['macrophases'].value[i]==null)">
                                                <div class="margin-bottom">
                                                    <strong class="strong-text inline">{{'LABEL.QTYMANODOPERA' |
                                                        translate}}:</strong>
                                                    <p class="margin-left margin-bottom inline">
                                                        {{getValueForResume(this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value,
                                                        "qtOreManodopera")}}</p>
                                                </div>
                                                <div class="margin-bottom">
                                                    <strong class="strong-text inline">{{'LABEL.QTYTOPRODUCT' |
                                                        translate}}:</strong>
                                                    <p class="margin-left margin-bottom inline">
                                                        {{getValueForResume(this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value,
                                                        "qtToProduct")}}</p>
                                                </div>
                                                <div class="margin-bottom">
                                                    <strong class="strong-text inline">{{'LABEL.NETPRICE' |
                                                        translate}}:</strong>
                                                    <p class="margin-left margin-bottom inline">
                                                        {{getValueForResume(this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value,
                                                        "priceNet")}}</p>
                                                </div>
                                            </div>

                                        </div>

                                        <span class="form-column-rev">
                                            <span class="form-row-rev">
                                                <span
                                                    *ngIf="editableEstimate() && visibleOnlyIfHasNoDeliberatePhases(i)"
                                                    class="material-icons-outlined icnc"
                                                    (click)="removeRow(i)">remove</span>

                                                <mat-icon *ngIf="openDetails[i].open == false"
                                                    [matBadge]="getNumberBadge(i)" matBadgeColor="primary"
                                                    (click)="expandRow(i)">expand_more</mat-icon>
                                                <mat-icon *ngIf="openDetails[i].open == true"
                                                    [matBadge]="getNumberBadge(i)" matBadgeColor="primary"
                                                    (click)="expandRow(i)">expand_less</mat-icon>

                                            </span>
                                            <span class="form-row-rev">
                                                <mat-icon
                                                    *ngIf="(editableEstimate() && orderFormGroup.controls['macrophases'].value[i].controls['macrophase'].value.isFreeDatas==true) || isStateCategoryWarranty()==true"
                                                    (click)="addFreeRow(i)">add</mat-icon>
                                            </span>
                                        </span>

                                    </mat-card>

                                    <div *ngIf="openDetails[i].open == true">
                                        <table class="table-responsive">
                                            <tbody class="phaseBlock">
                                                <tr class="firstRow">
                                                    <th></th>
                                                    <th></th>
                                                    <th></th>
                                                    <th></th>
                                                    <th></th>
                                                    <th></th>
                                                    <th></th>
                                                    <th></th>
                                                    <th></th>
                                                    <th></th>
                                                    <th></th>
                                                </tr>
                                                <ng-container
                                                    *ngFor="let phaseForm of orderFormGroup.controls['macrophases'].value[i].controls['phases'].value; let j = index">
                                                    <tr *ngIf="showPhaseRow(i, j)" [ngClass]="addPhaseClass(i, j)">
                                                        <!--<td><pre>{{this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j].controls['isFreeDatas'].value|json}}</pre></td>-->
                                                        <td>
                                                            <mat-checkbox class="cb-margin"
                                                                (change)="changeSelected($event, i, j)"
                                                                [formControl]="this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j].controls['selected']">
                                                            </mat-checkbox>
                                                        </td>
                                                        <td>
                                                            <span class="group-phase-name">
                                                                <span class="phase-name">
                                                                    <b>
                                                                        {{this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j].controls['phase'].value.name}}</b>
                                                                    <i class="isRequired" *ngIf="isMandatory(i, j)">
                                                                        *</i>
                                                                </span>
                                                                <input class="input-phase-desc"
                                                                    *ngIf="this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j].controls['isFreeDescription'].value == true"
                                                                    [formControl]="this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j].controls['freeDescription']"
                                                                    [placeholder]="translate.instant('LABEL.isFreeDescription')">
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <div *ngIf="!interfaceChangesForDubai()">
                                                                <div *ngIf="!(this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j].controls['isFreeDatas'].value==true)"
                                                                    class="info-row-phase">
                                                                    <label>{{'LABEL.ProdOrariaRif' | translate}}</label>
                                                                    <span>&nbsp;<b>{{this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j].controls['phase'].value.qProdOraria}}</b></span>
                                                                </div>

                                                                <mat-form-field
                                                                    *ngIf="this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j].controls['isFreeDatas'].value==true"
                                                                    class="field-row-phase">
                                                                    <input [readonly]="isReview == true" matInput
                                                                        type="number"
                                                                        [formControl]="this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j].controls['qProdOrariaRif']"
                                                                        [placeholder]="translate.instant('LABEL.ProdOrariaRif')"
                                                                        (ngModelChange)="changeAmmQt(i,j,$event)">
                                                                </mat-form-field>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div class="info-row-phase">
                                                                <label *ngIf="!isMultiservice">{{'LABEL.OreManodopera' |
                                                                    translate}}</label>
                                                                <label
                                                                    *ngIf="isMultiservice">{{'LABEL.OrePerRisorsaAPassaggio'
                                                                    | translate}}</label>
                                                                <span>&nbsp;<b>{{this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j].controls['qtOreManodopera'].value}}</b></span>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div *ngIf="!interfaceChangesForDubai()">
                                                                <div *ngIf="!(this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j].controls['isFreeDatas'].value==true)"
                                                                    class="info-row-phase">
                                                                    <label>{{'LABEL.CostoMaterialeRif' |
                                                                        translate}}</label>
                                                                    <span>&nbsp;<b>{{this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j].controls['phase'].value.cMater}}</b></span>
                                                                </div>

                                                                <mat-form-field
                                                                    *ngIf="this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j].controls['isFreeDatas'].value==true"
                                                                    class="field-row-phase">
                                                                    <input [readonly]="isReview == true" matInput
                                                                        type="number"
                                                                        [formControl]="this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j].controls['cMaterRif']"
                                                                        [placeholder]="translate.instant('LABEL.CostoMaterialeRif')"
                                                                        (ngModelChange)="changeAmmQt(i,j,$event)">
                                                                </mat-form-field>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div *ngIf="!interfaceChangesForDubai()">
                                                                <div class="info-row-phase">
                                                                    <label>{{'LABEL.TotaleListino' | translate}}</label>
                                                                    <span>&nbsp;<b>{{this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j].controls['price'].value}}</b></span>
                                                                </div>
                                                            </div>

                                                        </td>

                                                        <td>
                                                            <mat-form-field
                                                                *ngIf="!interfaceChangesForDubai() && this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j].controls['selected'].value==true"
                                                                class="field-row-phase">
                                                                <input
                                                                    [readonly]="this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j]?.controls['isFixedPrice']?.value || isReview == true || (!editableEstimate() && isStateCategoryWarranty() == false) || disableIfAlreadyDeliberate(i,j)"
                                                                    matInput type="number" min="20" max="100"
                                                                    [formControl]="this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j].controls['percAmmaloramento']"
                                                                    [placeholder]="translate.instant('LABEL.ISPERCAMMALORAMENTO')"
                                                                    (ngModelChange)="changeAmmQt(i,j,$event)">
                                                            </mat-form-field>
                                                        </td>
                                                        <td>
                                                            <mat-form-field
                                                                *ngIf="this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j].controls['selected'].value==true"
                                                                class="field-row-phase">
                                                                <input
                                                                    [readonly]="this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j]?.controls['isFixedPrice']?.value || (!editableEstimate() && isStateCategoryWarranty() == false) || disableIfAlreadyDeliberate(i,j)"
                                                                    matInput type="number"
                                                                    [min]="this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j]?.controls['phase']?.value?.minQuantity"
                                                                    [max]="this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j]?.controls['phase']?.value?.maxQuantity"
                                                                    [formControl]="this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j].controls['qtToProduct']"
                                                                    [placeholder]="translate.instant('LABEL.QTYTOPRODUCT')"
                                                                    (ngModelChange)="changeAmmQt(i,j,$event)">
                                                            </mat-form-field>
                                                        </td>
                                                              <td>
                                                                <mat-form-field
                                                                *ngIf="!interfaceChangesForDubai() && this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j].controls['selected'].value==true"
                                                                class="field-row-phase">
                                                                <input
                                                                    [readonly]="true"
                                                                    matInput type="text"
                                                                    [value]="this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j].controls['unitMeasure']?.value?.uiLabel"
                                                                    [placeholder]="translate.instant('LABEL.unitMeasure')">
                                                            </mat-form-field>
                                                        </td>
                                                        <td>
                                                            <mat-form-field
                                                                *ngIf="this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j].controls['selected'].value==true"
                                                                class="field-row-phase">
                                                                <input
                                                                    [readonly]="this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j]?.controls['isFixedPrice']?.value || isReview == true || isStateCategoryWarranty()==true || !editableEstimate() || disableIfAlreadyDeliberate(i,j)"
                                                                    matInput type="number"
                                                                    [formControl]="this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j].controls['priceNet']"
                                                                    [placeholder]="translate.instant('LABEL.NETPRICE')"
                                                                    (ngModelChange)="setFinanziamento()">
                                                            </mat-form-field>
                                                        </td>
                                                        <td
                                                            *ngIf="this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j].controls['phase'].value.isOtherCost == true">
                                                            <mat-form-field
                                                                *ngIf="this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j].controls['selected'].value==true"
                                                                class="field-row-phase">
                                                                <input
                                                                    [readonly]="isReview == true || isStateCategoryWarranty()==true || !editableEstimate()"
                                                                    matInput type="number"
                                                                    [formControl]="this.orderFormGroup.controls['macrophases'].value[i].controls['phases'].value[j].controls['otherCost']"
                                                                    placeholder="Altri costi">
                                                            </mat-form-field>
                                                        </td>
                                                    </tr>
                                                </ng-container>
                                            </tbody>
                                        </table>
                                    </div>
                                </span>
                            </mat-card-content>
                        </mat-card>

                        <ng-template #noBoxWorking>
                            <mat-card class="mrg-com-cont">
                                <mat-card-title class="card-title row-panel">
                                    <span class="row-panel-group-rigth">
                                        <span class="material-icons">engineering</span>&nbsp;
                                        <span> {{ 'ORDERS.LAVORAZIONI' | translate }} ( {{ 'LABEL.PREZZO_NETTO_TOTALE' |
                                            translate }}: {{getRicavoReale() | number: '1.2-2'}} )</span>
                                    </span>

                                </mat-card-title>
                                <mat-card-content>
                                    <p style="color:red;">{{ 'LABEL.noBoxWorking' | translate }}</p>
                                </mat-card-content>
                            </mat-card>

                        </ng-template>



                        <!-- METODI DI PAGAMENTO -->
                        <mat-card class="mrg-com-cont paymentMethodCard"
                            *ngIf="!interfaceChangesForDubai() && !isStateCategoryWarranty()">
                            <mat-card-title class="card-title row-panel">
                                <span class="row-panel-group-rigth">
                                    <span class="material-icons">assignment</span>&nbsp;
                                    <span> {{ 'LABEL.PaymentMethod' | translate }}</span>
                                </span>
                                <span style="margin-left: auto;">
                                    <button aria-label="Descrizioni metodi di pagamento"
                                        [disabled]="isPaymentMethodModified || !originalPaymentMethodId"
                                        (click)="modalForCustomDescriptionsForPaymentSteps()" type="button"
                                        class="btn styleButton mx-2 acrobaticaButton">
                                        <mat-icon class="material-icons">label</mat-icon>
                                        {{ 'LABEL.editPaymentMethodDescription' | translate }}
                                    </button>
                                    <button aria-label="Aggiungi Metodo di Pagamento"
                                        *ngIf="checkComponent('addNewPaymentMethod')"
                                        (click)="openAddNewPaymentMethodModalComponent()" type="button"
                                        class="btn styleButton mx-2 clsButtonDefault">
                                        <mat-icon class="material-icons">add</mat-icon>
                                        {{ 'LABEL.AddNewPaymentMethod' | translate }}
                                    </button>
                                </span>
                            </mat-card-title>
                            <mat-card-content>
                                <div class="form-row">

                                    <!-- Messaggio informativo per modifica metodo di pagamento -->
                                    <div class="card-row" *ngIf="checkComponent('checkAndChangePaymentMethod')">
                                        <div class="mrg-com-cont full"
                                            style="background-color: #e3f2fd; padding: 10px; border-radius: 4px; border-left: 4px solid #2196F3;">
                                            <mat-icon
                                                style="vertical-align: middle; color: #2196F3; margin-right: 8px;">info</mat-icon>
                                            <span style="vertical-align: middle;">{{ 'LABEL.PAYMENT_METHOD_CHANGE_INFO'
                                                | translate }}</span>
                                        </div>
                                    </div>

                                    <div class="card-row">
                                        <mat-form-field class="mrg-com-cont full" appearance="fill">
                                            <mat-label>{{'LABEL.PaymentMethod' | translate }}</mat-label>
                                            <mat-select formControlName="paymentMethodId"
                                                (selectionChange)="onPaymentMethodChange()">
                                                <mat-option [disabled]="disablepaymentOption(paymentMethod)"
                                                    [selected]="paymentMethod.id == orderFormGroup.controls['paymentMethodId'].value"
                                                    *ngFor="let paymentMethod of paymentMethods"
                                                    [value]="paymentMethod.id">
                                                    {{paymentMethod.label}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>

                                    <!-- Bottone Salva Modifica - visibile solo se modificato e checkComponent è true -->
                                    <div class="card-row"
                                        *ngIf="isPaymentMethodModified && checkComponent('checkAndChangePaymentMethod')">
                                        <button mat-raised-button color="primary" (click)="savePaymentMethodChange()"
                                            class="mrg-com-cont" type="button">
                                            {{ 'LABEL.SaveChange' | translate }}
                                        </button>
                                    </div>

                                    <!-- Elenco steps del metodo di pagamento selezionato -->
                                    <div class="card-row" *ngIf="getSelectedPaymentMethodSteps().length > 0">
                                        <div class="payment-method-steps-container mrg-com-cont full">
                                            <div class="payment-method-steps-list">
                                                <p>Steps:</p>
                                                <div class="payment-method-step-item"
                                                    *ngFor="let step of getSelectedPaymentMethodSteps(); let i = index">
                                                    <span class="step-number">{{ i + 1 }}.</span>
                                                    <span class="step-label">{{ getPaymentMethodStepLabel(step)
                                                        }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </mat-card-content>
                        </mat-card>

                    </div>
                </form>
                <div>
                    <button style="background-color:transparent;" type="button" class="btn btn-primary"
                        matStepperPrevious>
                        <mat-icon class="material-icons" style="color:#293683;">arrow_back</mat-icon>
                    </button>
                    <button style="background-color:transparent;" type="button" class="btn btn-primary" matStepperNext>
                        <mat-icon class="material-icons" style="color:#293683;">arrow_forward</mat-icon>
                    </button>
                </div>
            </ng-container>
        </mat-step>
        <mat-step label="Finance" state="checked" #four_step>
            <ng-container *ngIf="stepper.selected == null || stepper.selected == four_step">
                <mat-expansion-panel style="margin:5px; width: 100%;">
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <span class="my-bounce material-icons">redeem</span>
                            <div class="fw-bolder text-dark"> {{ 'LABEL.Certificati' | translate }}</div>
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <div class="row g-6 g-xl-9">

                        <iframe *ngIf="certurl" id="CertificatesIframe_practice" style="width: 100%; height: 769px;"
                            [src]="certurl | safe" title="Invoice Certificates"></iframe>

                    </div>
                </mat-expansion-panel>

                <div>
                    <button style="background-color:transparent;" type="button" class="btn btn-primary"
                        matStepperPrevious>
                        <mat-icon class="material-icons" style="color:#293683;">arrow_back</mat-icon>
                    </button>
                    <button style="background-color:transparent;" type="button" class="btn btn-primary" matStepperNext>
                        <mat-icon class="material-icons" style="color:#293683;">arrow_forward</mat-icon>
                    </button>
                </div>
            </ng-container>
        </mat-step>
        <mat-step label="WorkFlow" #five_step>
            <ng-container *ngIf="stepper.selected == null || stepper.selected == five_step">

                <div *ngIf="!(order == null)" class="flex-column mrg">
                    <h2 class="mb-1">{{'practice_workflow_manager.title' | translate}}</h2>

                    <!-- COMPONENTE DOCUMENTALE -->
                    <div *ngIf="checkComponent('practice_workflow_manager'); else elseBlock">
                        <app-practice-workflow-manager [form]="orderFormGroup" *ngIf="practice && documents && order"
                            [disableUpload]="disableUpload" [isNew]="isNew" [components]="components"
                            [practice]="practice" [documents]="documents"
                            [order]="order"></app-practice-workflow-manager>
                    </div>
                    <ng-template #elseBlock>
                        <strong style="color:red">{{'practice_workflow_manager.noDocumentsNeed' | translate}}</strong>
                    </ng-template>

                </div>


                <hr style="margin:50px 0;">

                <div *ngIf="!(order == null)" class="flex-column mrg">
                    <h2 class="mb-1">{{'WORKFLOW.logSectionTitle' | translate}}</h2>

                    <!-- COMPONENTE LINK PRACTICE -->
                    <app-practices-history [reasons]="reasons" [stateCategories]="stateCategories"
                        [practiceLogs]="practiceLogs" [components]="components" [id]="practice.id"
                        *ngIf="practice && practiceLogs" [form]="orderFormGroup"></app-practices-history>

                </div>

                <br />
            </ng-container>
        </mat-step>
        <mat-step label="{{'LABEL.Documenti' | translate}}" [editable]="false" #six_step>
            <ng-container *ngIf="stepper.selected == null || stepper.selected == six_step">

                <app-practice-document [documents]="documents" [orderVersions]="orderVersions"></app-practice-document>


            </ng-container>
        </mat-step>


    </mat-stepper>
    <br>
    <div class="buttons-right">
        <button *ngIf="editableEstimate() || isStateCategoryWarranty()" style="background-color:transparent;"
            [disabled]="!orderFormGroup?.valid || disableSaveButtonIfQtToProduct()" matTooltip="Salva" type="button"
            class="my-bounce btn btn-primary mx-2" (click)="checkAndUpdate()">
            <mat-icon class="material-icons" style="color:#293683;">save</mat-icon>
        </button>
    </div>
</div>